import React, { useState } from 'react';
import MasterPage from '../../../EstruturaAntiga/masterpages/authenticated';
import { Button, Form, Modal, Steps } from 'antd';
import LoadingOrErrorPanel from 'components/LoadingOrErrorPanel';
import { useUsuarioRestaurar } from '../../../hooks/useUsuarioRestaurar';
import DadosUsuario from './Components/DadosUsuario';
import SelecaoLicencas from './Components/SelecaoLicencas';
import Confirmacao from './Components/Confirmacao';
import { useGerenciadorDeLicencas } from 'hooks/useGerenciadorDeLicencas';
import UsuariosService from 'services/UsuariosService';
import { useAuth } from 'context/AuthContext';
import policiesObject from 'EstruturaAntiga/pages/Provisionamento/polices.json';
import { NotificationManager } from 'react-notifications';
import { ModalSucesso } from 'components/Modais/ModalSucesso';

const RestaurarUsuario = ({ history }) => {
    const [formularioDados] = Form.useForm();

    const [dadosPreenchidos, setDadosPreenchidos] = useState(false)
    const [licencasPreenchidas, setLicencasPreenchidas] = useState(false)
    const [termoAceito, setTermoAceito] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    
    const [dadosUsuario, setDadosUsuario] = useState({})
    const pathParts = history.location.pathname.split('/');
    const id = pathParts[pathParts.length - 1];
    const {direito} = useAuth()
    const {
        hasError,
        loading,
        formularioProps,
        validarEmail,
        getCampoStatus,
    } = useUsuarioRestaurar({form: formularioDados, usuarioId: id})

    const { gerenciadorProps, estado } = useGerenciadorDeLicencas({
        planoInicial: null,
        licencasIniciais: []
    });

    const [stepAtual, setStepAtual] = useState(0)

    const onNext = async () =>{

        if(stepAtual === 0){
            const valoresAtuais = formularioDados.getFieldsValue(true)
            const emailPrincipal = `${valoresAtuais.dominio}@${valoresAtuais.dominioSufixo}`;
                console.log(getCampoStatus('dominio'));
            if (getCampoStatus('dominio') !== 'success') {
                const emailValido = await validarEmail(emailPrincipal);
                console.log(emailValido);
                if (!emailValido) return;
            }

            setDadosUsuario({
                ...valoresAtuais,
                emailPrincipal: emailPrincipal
            });
        }
        setStepAtual(prev => Math.min(prev+1, 2))
    }
    const onBack = () =>{
        setStepAtual(prev => Math.max(prev-1, 0))
    }

    const renderSteps = () => {
        return (
            <React.Fragment>
                <div style={{display: stepAtual == 0 ? "block": "none"}}>
                    <DadosUsuario formRef={formularioDados} onSubmitableChange={(value)=>setDadosPreenchidos(value)} {...formularioProps}/>
                </div>
                <div style={{display: stepAtual == 1 ? "block": "none"}}>
                    <SelecaoLicencas onSubmitableChange={(value)=>setLicencasPreenchidas(value)} {...gerenciadorProps}/>
                </div>
                <div style={{display: stepAtual == 2 ? "block": "none"}}>
                    <Confirmacao formData={dadosUsuario} licenciamento={estado} termoAceito={termoAceito} onTermoAceitoChange={setTermoAceito}/>
                </div>
            </React.Fragment>
        )
    }
    const ValidaNext = () => {
        if(stepAtual == 0){
            return !dadosPreenchidos
        }else if(stepAtual == 1){
            return !licencasPreenchidas || !estado.planoDisponivel
        }
        return true
    }

    const OnSubmit = () =>{
        const planoSelecionado = estado.planos.find(p => p.value === estado.planoSelecionado);
        var data = {
            "UsuarioId": id,
            "TenantId": direito.axtTenantId,
            "DireitoId": direito.entitlementId,
            "LoginUsuario": dadosUsuario.LoginUsuario,
            "NomeParaExibicao": dadosUsuario.nomeParaExibicao,
            "Departamento": dadosUsuario.departamento,
            "EmailPrincipal": dadosUsuario.emailPrincipal,
            "EmailAlternativo": dadosUsuario.emailAlternativo,
            "Nome": dadosUsuario.nome,
            "Sobrenome": dadosUsuario.sobrenome,
            "Cargo": dadosUsuario.cargo,
            "TelefoneCelular": dadosUsuario.telefoneCelular,
            "TelefoneComercial": dadosUsuario.telefoneComercial,
            "TermoContratoAceito": JSON.stringify(policiesObject),
            ...(dadosUsuario.habilitarMFA && { "habilitarMFA": dadosUsuario.habilitarMFA }),
            "ProdutoPrincipal": {
                "ProdutoPrincipalId": planoSelecionado.value,
                "UnidadePrincipalId": planoSelecionado.unidadeId
            },
            "ProdutosOpcionais": estado.licencasSelecionadas.map(l => {
                const licenca = estado.licencasAdicionais.find(lo => lo.value === l);
                return {
                    "ProdutoId": licenca.value,
                    "UnidadeId": licenca.unidadeId
                }
            }),
            "PerfisDeAcessoAosDireitos": dadosUsuario.perfis.map(x=>{ return { "DireitoId": x.direito.value, "PerfilDeAcesso": String(x.perfil.value)}}),
            "AtributosEstendidos": {
                "AtributoEstendido2": dadosUsuario.codigoCliente,
                "AtributoEstendido3": dadosUsuario.razaoSocial,
                "AtributoEstendido4": dadosUsuario.cnpj,
                "AtributoEstendido5": dadosUsuario.codigoAssessor
            }
        }
        UsuariosService.RestaurarUsuario(data)
            .then(() => {
                ModalSucesso("Sucesso!",`A restauração do usuário ${dadosUsuario.nomeParaExibicao} está sendo processada. Em até 20 minutos você receberá um e-mail informando sobre a conclusão.`)
                history.push("/usuarios-excluidos")
            })
            .catch((error) => {
                const mensagensErro = error.response?.data?.erros ?? ['Erro ao tentar restaurar o usuário.'];
                mensagensErro.forEach(msg => NotificationManager.error(msg, 'Erro', 5000));                
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    }

    return (
        <MasterPage>
            <LoadingOrErrorPanel loading={loading} hasError={hasError}>
                <Steps current={stepAtual} labelPlacement="vertical" size="small">
                    <Steps.Step title="Dados do Usuário" disabled={true} />
                    <Steps.Step title="Licenciamento e Planos" disabled={true} />
                    <Steps.Step title="Confirmação e Finalização" disabled={true} />
                </Steps>
                {renderSteps()}
                <div style={{ marginTop: 24, display: 'flex', justifyContent: 'space-between' }}>
                    <Button onClick={() => stepAtual === 0 ? history.push("/usuarios-excluidos") : onBack()}>
                        {stepAtual === 0 ? 'Sair' : 'Voltar'}
                    </Button>
                    
                    <div>
                        {stepAtual < 2
                            ? <Button onClick={()=>{onNext()}} type='primary' disabled={ValidaNext()}>Próximo</Button>
                            : <Button onClick={()=>{OnSubmit()}} type='primary' disabled={!termoAceito || isSubmitting} loading={isSubmitting}>Restaurar</Button>
                        }
                    </div>
                </div>
            </LoadingOrErrorPanel>
        </MasterPage>
    );
};

export default RestaurarUsuario;